<script setup lang="ts">
import type { ISbStoryData } from '@storyblok/vue'
import { StoryblokComponent, useStoryblok } from '@storyblok/vue'
import { StoryblokHelper } from '../lib'
import { SEO } from '~~/src/utils/constants'

const route = useRoute()
const router = useRouter()

const runtimeConfig = useRuntimeConfig()

const story = asyncComputed<ISbStoryData | null>(async () => {
  const routeMetaStory = route.meta.story as ISbStoryData | undefined

  if (routeMetaStory)
    return routeMetaStory

  const slug = route.path.split('/').pop()
  if (!slug) {
    router.push('/')
    return null
  }

  const environment = runtimeConfig.public.environment.toLowerCase()
  const version = StoryblokHelper.getEnvironmentVersion(environment)

  const story = await useStoryblok(slug, {
    version,
  })

  return story.value
})

const title = computed(() => {
  const storyTitle = story?.value?.content?.title || SEO.title
  return storyTitle
})

useHead({
  meta: [
    { name: 'og:title', content: title },
  ],
})
</script>

<template>
  <NuxtLayout name="storyblok">
    <StoryblokComponent v-if="story" :blok="story.content" />
  </NuxtLayout>
</template>
